import { RemoteUserConfirmAccount } from '../../../data/usecases/user-confirm-account/remote-user-confirm-account'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeConfirmAccount = () => new RemoteUserConfirmAccount('/public/register/confirm-account', makeAxiosHttpClient())
